import {ProductViewModel} from './ProductViewModel';
import {CategoryViewModel} from './CategoryViewModel';

export class SearchBoxResponseModel {
  public token: string;
  public products: ProductViewModel[];
  public categories: CategoryViewModel[];
  public hasMoreProducts: boolean;

  static convertFromOld(_oldObject: any): SearchBoxResponseModel {
    const searchBoxResponseModel = new SearchBoxResponseModel();

    searchBoxResponseModel.categories = [];
    searchBoxResponseModel.products = _oldObject.suggestions.reduce((_acc, _product) => {
      const productName = _product.term;
      const product = ProductViewModel.simple(productName);

      product.picture.url = '';
      product.brandName = '';
      product.frameColour = '';
      product.price.formattedValue = '';
      product.discountPrice.formattedValue = '';

      _acc.push(product);

      return _acc;
    }, []);

    return searchBoxResponseModel;
  }
}
